import React, { useState, useEffect } from 'react';
import * as actions from './paymentMethodsActions';
import { connect } from 'react-redux';
import PaymentMethods from './PaymentMethods';
import PaymentMethodFormContainer from './PaymentMethodForm/PaymentMethodFormContainer';
import ConfirmDelete from './components/ConfirmDelete';
import {
  showGiftCardModal,
  initiateReloadGiftCard,
  reloadGiftCard,
} from '../GiftCard/giftCardActions';

const PaymentMethodsContainer = ({
  // paymentMethods,
  paymentMethodsReducer,
  getPaymentMethods,
  setDefaultPaymentMethod,
  showConfirmDeletePaymentMethod,
  hideConfirmDeletePaymentMethod,
  deletePaymentMethod,
  noDialogBackground,
  showGiftCardModal,
  initiateReloadGiftCard,
  reloadGiftCard,
  isForGiftCard,
  sourceConfig,
  openInModal,
  defaultPaymentMethod,
  showPaymentMethodSelectionForm,
  isForCheckoutPage,
}) => {
  const {
    paymentMethods,
    // requestingGetPaymentMethods,
    confirmDeletePaymentMethodIsVisible,
    requestingDeletePaymentMethod,
    paymentMethodsModalIsVisible,
  } = paymentMethodsReducer;

  const isGiftCardEnabled = sourceConfig.payment_methods.includes('giftcard');

  useEffect(() => {
    if (!paymentMethods) {
      getPaymentMethods();
    }
  }, []);

  const [editStateIsVisible, setEditStateIsVisible] = useState(false);
  const [cardIdToDelete, setCardIdToDelete] = useState(null);

  useEffect(() => {
    if (!confirmDeletePaymentMethodIsVisible) {
      setEditStateIsVisible(false);
      setCardIdToDelete(null);
    }
  }, [requestingDeletePaymentMethod]);

  const handleCancelDeletePaymentMethod = () => {
    setCardIdToDelete(null);
    hideConfirmDeletePaymentMethod();
  };

  const initiateDeletePaymentMethod = (cardId) => {
    setCardIdToDelete(cardId);
    showConfirmDeletePaymentMethod();
  };

  const handleDeletePaymentMethod = () => deletePaymentMethod(cardIdToDelete);

  return (
    <>
      <PaymentMethods
        paymentMethods={paymentMethods}
        setDefaultPaymentMethod={setDefaultPaymentMethod}
        editStateIsVisible={editStateIsVisible}
        initiateDeletePaymentMethod={initiateDeletePaymentMethod}
        noDialogBackground={noDialogBackground}
        showGiftCardModal={showGiftCardModal}
        initiateReloadGiftCard={initiateReloadGiftCard}
        reloadGiftCard={reloadGiftCard}
        isForGiftCard={isForGiftCard}
        isForCheckoutPage={isForCheckoutPage}
        sourceConfig={sourceConfig}
        paymentMethodsModalIsVisible={paymentMethodsModalIsVisible}
        isGiftCardEnabled={isGiftCardEnabled}
        openInModal={openInModal}
        defaultPaymentMethod={defaultPaymentMethod}
        showPaymentMethodSelectionForm={showPaymentMethodSelectionForm}
      />
      <PaymentMethodFormContainer />
      <ConfirmDelete
        handleCancelDeletePaymentMethod={handleCancelDeletePaymentMethod}
        confirmDeletePaymentMethodIsVisible={
          confirmDeletePaymentMethodIsVisible
        }
        requestingDeletePaymentMethod={requestingDeletePaymentMethod}
        handleDeletePaymentMethod={handleDeletePaymentMethod}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  paymentMethods: state.authReducer.paymentMethods,
  paymentMethodsReducer: state.paymentMethodsReducer,
  sourceConfig: state.authReducer.appConfig,
});

export default connect(mapStateToProps, {
  ...actions,
  showGiftCardModal,
  initiateReloadGiftCard,
  reloadGiftCard,
})(PaymentMethodsContainer);
